import { toast } from "react-toastify";
export const openErrorToast = (message) => {
  toast.error(message, {
    position: "bottom-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};
export const openSuccessToast = (message) => {
  toast.success(message, {
    position: "bottom-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};
// El backend responde {"message": "..."} con el motivo real (regla de negocio,
// dato duplicado, etc.). Antes se descartaba y siempre se mostraba el texto
// generico de cada pantalla, asi que el usuario no sabia que habia pasado.
const mensajeDelServidor = (error) => {
  const data = error?.response?.data;
  return typeof data?.message === "string" && data.message.trim() !== ""
    ? data.message
    : null;
};

export const errorHandler = (error, message) => {
  const status = error?.response?.status;

  if (status === 401 || status === 403) {
    openErrorToast(
      mensajeDelServidor(error) ||
        "Su sesión expiró o no tiene permisos. Vuelva a iniciar sesión."
    );
    return;
  }

  if (!error?.response) {
    openErrorToast("No hay conexión con el servidor. Revise su red.");
    return;
  }

  openErrorToast(
    mensajeDelServidor(error) || message || "Ocurrió un error inesperado."
  );
};
